var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { characterCountStyle } from './styles';
function CharacterCount(_a) {
    var value = _a.value, limit = _a.limit, id = _a.id, inverted = _a.inverted;
    var count = (value === null || value === void 0 ? void 0 : value.toString().length) || 0;
    return (_jsx(Text, __assign({ as: "p", id: id, "aria-label": "".concat(count, " of ").concat(limit, " characters used"), css: characterCountStyle({ inverted: inverted }) }, { children: "".concat(count, " / ").concat(limit) })));
}
export default CharacterCount;
